export default __webpack_public_path__ + "static/media/facade.3057063d.jpg";